import axios from "../../Axios";
import { Urls } from "../../Urls";
import { Activity, currentRequestTimeStamp } from "../../Constants";
import { buildTrucksAvailableLane, buildTransporterEntry } from "./spotLaneFormatter";

/**
 * Validates the core adhoc lane input fields.
 * 
 * @param {Object} data 
 * @returns {{ valid: boolean, message: string }}
 */
export const validateAdhocLane = (data) => {
  const { origin, destination, selectedTrucks, truckrequired, tonnage } = data;
  const validPattern = /^[0-9.,\-]+$/;
  const sqlPattern = /\b(SELECT\s+\*|INSERT\s+INTO|DELETE\s+FROM|UPDATE\s+\w+|DROP\s+TABLE|ALTER\s+TABLE|TRUNCATE\s+TABLE|EXEC\s+\w+|UNION\s+SELECT)\b|(--|;|'|"|\/\*|\*\/)/gi;

  if (sqlPattern.test(origin.location_name) || sqlPattern.test(destination.location_name) || sqlPattern.test(selectedTrucks)) {
    return { valid: false, message: "Please enter valid input" };
  }
  if (!origin.location_name || !destination.location_name) {
    return { valid: false, message: "Please Enter Origin and Destination" };
  }
  if (!selectedTrucks || selectedTrucks.length === 0) {
    return { valid: false, message: "Please Enter Truck Type" };
  }
  if (truckrequired < 0 || !validPattern.test(truckrequired)) {
    return { valid: false, message: "Please enter valid Truck type!" };
  }
  if (origin.location_name === destination.location_name) {
    return { valid: false, message: "Origin and destination cannot be same" };
  }
  if (tonnage !== undefined && tonnage !== null && tonnage !== "" && tonnage !== 0 && tonnage !== "0") {
    if (!validPattern.test(tonnage) || tonnage < 0) {
      return { valid: false, message: "Please enter valid Weight!" };
    }
  }
  return { valid: true };
};

/**
 * Processes the addition of a new  lane (TrucksAvailable flow).
 * 
 * Extracted from NewEnquiry.addLanetoProcurement().
 * 
 * @param {Object} params
 * @returns {Promise<Object>} The new lane object.
 */
export const buildAdhocLaneList = async ({
  origin,
  destination,
  selectedTrucks,
  truckrequired,
  tonnage,
  capacity,
  date,
  tenure,
  selectedIndustry,
  mastertransporterlist = [],
  TrackMixPanel
}, email, userName) => {
  // Activity tracking
  Activity([
    {
      screen: "LoRRI Spot",
      module: "New enquiry",
      user_activity: "add button clicked to add new lane",
      timestamp: currentRequestTimeStamp(),
      userName: userName,
      userEmail: email,
      companyname: email
        ? email.split("@")[1].split(".")[0]
        : ""
    },
  ]);

  // Mixpanel tracking
  if (TrackMixPanel) {
    TrackMixPanel({
      ModuleName: "lorri spot",
      ScreenName: "my enquiries",
      Data: `lane: ${origin.location_name ?? ""} to ${destination.location_name}, truck type: ${selectedTrucks[0].value}`,
      Definition: "user has added an enquiry",
    });
  }

  // Fetch Recommended Transporters
  const brlist = mastertransporterlist.length > 0
    ? mastertransporterlist.map((tr) => ({ ...tr, ischecked: true }))
    : [];

  // const resSave = await axios.post(`${Urls.save_transporters}?get_data=true`, {
  //   origin: { location_name: origin.location_name },
  //   destination: { location_name: destination.location_name },
  //   truck_type: selectedTrucks[0].value,
  // });

  // if (resSave.data.transporter_data?.length > 0) {
  //   resSave.data.transporter_data.forEach((br) => {
  //     brlist.push(buildTransporterEntry(br, true));
  //   });
  // }

  // const payload = {
  //   enquiry: {
  //     origin: {
  //       coordinates: origin.coordinates,
  //       location: [origin.location],
  //       location_name: origin.location_name,
  //     },
  //     destination: {
  //       coordinates: destination.coordinates,
  //       location: [destination.location],
  //       location_name: destination.location_name,
  //     },
  //     truck_types: selectedTrucks[0].value,
  //     truck_types_group: selectedTrucks[0].truck_types_group,
  //   },
  //   percentage_completion: 0,
  // };

  // await axios.post(`${Urls.RecommendTransporter}`, payload);

  return buildTrucksAvailableLane({
    origin,
    destination,
    selectedTrucks,
    truckrequired,
    date,
    tenure,
    brlist,
    capacity,
    tonnage,
    selectedIndustry
  });
};
